export default __webpack_public_path__ + "static/media/work-step-3.c93b87ed.png";